import 'vuetify/styles';
import { createVuetify } from 'vuetify';
import { aliases, mdi } from 'vuetify/iconsets/mdi-svg';

const lightTheme = {
  dark: false,
  colors: {
    background: '#F8F9FA', // Off-white
    surface: '#FFFFFF',
    'surface-variant': '#F3F4F6', // Light gray
    primary: '#1E3A5F', // Modern Navy
    secondary: '#1E3A5F', // Same as primary
    accent: '#FF6B6B', // Coral
    gold: '#D4AF37', // Gold accent
    error: '#EF4444',
    info: '#3B82F6',
    success: '#10B981',
    warning: '#F59E0B',
  },
};

const darkTheme = {
  dark: true,
  colors: {
    background: '#1A1A1A', // Charcoal
    surface: '#2D2D2D',
    'surface-variant': '#3D3D3D',
    primary: '#5B7FA8', // Lighter navy for dark mode (adjusted from #1E3A5F)
    secondary: '#5B7FA8', // Same as primary
    accent: '#FF8A8A', // Lighter coral for dark mode
    gold: '#E5C34F', // Lighter gold for dark mode
    error: '#EF4444',
    info: '#3B82F6',
    success: '#10B981',
    warning: '#F59E0B',
  },
};

export default createVuetify({
  theme: {
    defaultTheme: 'light',
    themes: {
      light: lightTheme,
      dark: darkTheme,
    },
    layers: true,
  },
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  defaults: {
    VBtn: {
      rounded: 'lg',
      elevation: 0,
      style: 'text-transform: none;',
    },
    VCard: {
      rounded: 'lg',
      elevation: 2,
      border: true,
    },
  },
});